<script>
  import { router } from "@spaceavocado/svelte-router";
  import firebase from "../lib/firebase";

  let user = firebase.auth().currentUser;

  export let host;

  const logoutHandler = () => {
    localStorage.removeItem("__wirus_token");
    firebase
      .auth()
      .signOut()
      .then(() => $router.push("/"));
  };

  const clearHost = () => {
    host = "";
    localStorage.removeItem("host");
  }
</script>

<style>
  .user-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: #00a676;
    color: white;
    border-radius: 20px;
    padding: 10px 10px;
    box-sizing: border-box;
    box-shadow: 3px 3px 10px -2px rgba(0, 0, 0, 0.2);
    margin-bottom: 20px;
  }

  .user-wrapper > div {
    display: flex;
    align-items: center;
  }

  .user-wrapper button:hover {
    border-color: white;
  }
  .user-info {
    margin: 0 5px 0 10px;
    font-size: 0.8rem;
  }

  .logout {
    font-size: 0.8rem;
    padding: 3px 10px;
    margin-left: 5px;
  }
</style>

<div class="user-wrapper">
  <div>
    {#if host}
      <div class="user-info">Host: {host} <i on:click={clearHost} class="fas fa-pen"></i></div>
    {/if}
  </div>
  <div>
    <div class="user-info">
      <i class="fas fa-user fa-sm" />
      {user.email}
    </div>

    <button class="logout" on:click={logoutHandler}>Logout</button>
  </div>
</div>
